import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class MenuService {
	mobileMenu: Observable<boolean>;
	private showMobileMenuSource: Subject<boolean>;

	constructor() {
		this.showMobileMenuSource = new Subject<boolean>();
		this.mobileMenu = this.showMobileMenuSource.asObservable();
	}

	showMobileMenu() {
		this.showMobileMenuSource.next(true);
	}

	hideMobileMenu() {
		this.showMobileMenuSource.next(false);
	}
}
